<template>
    <div class="bg-0A1129 text-white min-vh-100">
      <Mainlayout />
      <div class="container-fluid pt-5">
        <div class="row p-3">
          <div class="col-md-12">
            <div class="text-center mt-5">
              <img src="../assets/img/vectorfailed.png" width="135" height="135" />
              <h3 class="text-white mt-3">Pembayaran Gagal</h3>
              <h5 class="text-white mt-2">Sila semak transaksi anda atau hubungi sokongan kami.</h5>
              <CButton type="button" class="bg-1796FD text-white mt-4" @click="GoToProduct()">Close</CButton>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  </template>

<script>
import Vue from "vue";
import _ from "lodash";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "@/containers/AllHeader.vue";
import Footer from "@/components/Footer.vue";
export default {

  name: "Payment",
  components: {
      Mainlayout,
      Footer,

  },
  data() {
      return {
      }
    },
    methods:
    {
        GoToProduct()
        {
            this.$router.push("OurProduct");
        }
    }
}
</script>
